import { Component, ViewChild, inject } from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslatePipe} from "../../shared/pipes/translate.pipe";
import {LanguageService} from "../../shared/services/language.service";
import {HeadlineComponent} from "../../shared/elements/headline/headline.component";
import {IconBadgeComponent} from "../../shared/elements/icon-badge/icon-badge.component";
import {FormInputComponent} from "../../shared/elements/form-input/form-input.component";
import {FormBuilder, FormGroup} from '@angular/forms';
import {FormButtonComponent} from "../../shared/elements/form-button/form-button.component";
import {DialogComponent} from '@syncfusion/ej2-angular-popups';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import {FormDropdownComponent} from "../../shared/elements/form-dropdown/form-dropdown.component";
import {ToastModule} from '@syncfusion/ej2-angular-notifications';
import {LinkComponent} from "../../shared/elements/link/link.component";
import {LayoutService} from "../../shared/services/layout.service";
import {TooltipModule} from "@syncfusion/ej2-angular-popups";
import {TooltipComponent} from "../../shared/elements/tooltip/tooltip.component";
import {DialogService} from "../../shared/services/dialog.service";
import {StepHeaderComponent} from "../../shared/elements/step-header/step-header.component";
import {StepContentComponent} from "../../shared/elements/step-content/step-content.component";
import {FormLabelComponent} from "../../shared/elements/form-label/form-label.component";
import {FormCheckboxComponent} from "../../shared/elements/form-checkbox/form-checkbox.component";
import {FormRadioComponent} from "../../shared/elements/form-radio/form-radio.component";
import {ContentComponent} from "../../shared/elements/content/content.component";
import { TimePickerModule } from '@syncfusion/ej2-angular-calendars';
import {RouterService} from "../../shared/services/router.service";
import {LoadingService} from "../../shared/services/loading.service";
import {NgSrcImageErrorDirective} from '../../shared/directives/ng-src-image-error.directive';

@Component({
    selector: 'app-communitysd',
    imports: [
        CommonModule,
        DialogModule,
        TranslatePipe,
        HeadlineComponent,
        FormInputComponent,
        FormButtonComponent,
        FormDropdownComponent,
        ToastModule,
        IconBadgeComponent,
        LinkComponent,
        TooltipModule,
        TooltipComponent,
        StepHeaderComponent,
        StepContentComponent,
        FormLabelComponent,
        FormCheckboxComponent,
        FormRadioComponent,
        ContentComponent,
        TimePickerModule,
        NgSrcImageErrorDirective
    ],
    templateUrl: './communitysd.component.html',
    styleUrl: './communitysd.component.scss'
})
export class CommunitysdComponent {
  layoutService = inject(LayoutService);
  private formBuilder = inject(FormBuilder);
  private languageService = inject(LanguageService);
  dialogService = inject(DialogService);
  routerService = inject(RouterService);
  loadingService = inject(LoadingService);

  @ViewChild('topicNotifications') topicNotifications: DialogComponent | any;
  @ViewChild('createNewCommunityDialog') createNewCommunityDialog: DialogComponent | any;
  @ViewChild('manageWritersTopicList') manageWritersTopicList: DialogComponent | any;
  @ViewChild('manageWriters') manageWriters: DialogComponent | any;
  @ViewChild('relocateCommunityList') relocateCommunityList: DialogComponent | any;


  onOpenDialog = (event: any, id: string): void => {
    event.preventDefault();
    if(id == 'show-topicnotifications')
    {
      this.topicNotifications.show();
    }

    if(id == 'show-newcommunitydialog')
    {
      this.createNewCommunityDialog.show();
    }

    if(id == 'show-manageWriters')
    {
      this.manageWriters.show();
    }

    if(id == 'show-manageWritersTopicList')
    {
      this.manageWritersTopicList.show();
    }

    if(id == 'show-relocateCommunityList')
    {
      this.relocateCommunityList.show();
    }
  };

  onClose(id: string): void{
    if(id == 'show-topicnotifications')
    {
      this.topicNotifications.hide();
    }

    if(id == 'show-newcommunitydialog')
    {
      this.createNewCommunityDialog.hide();
    }

    if(id == 'show-manageWriters')
    {
      this.manageWriters.hide();
    }

    if(id == 'show-manageWritersTopicList')
    {
      this.manageWritersTopicList.hide();
    }

    if(id == 'show-relocateCommunityList')
    {
      this.relocateCommunityList.hide();
    }
  }
  /**** FORM GROUP */
  public communityForm: FormGroup = this.formBuilder.group({
    searchString: [''],
    search_filter: ['discussion'],
    display_filter: ['all'],
    topic_notifications: ['all'],
    topic_notifications_bymail: [''],
    topic_notifications_bypush: [''],
    community_title: [''],
    community_description: [''],
    community_visibility: [0],
    search_topic_name: ['']
  });

  searchFilterOptions: any[] = [
    {id: 'discussion', name: this.languageService.getTranslationByKey('COMMUNITYSEARCHINDISCUSSIONS')},
    {id: 'topic_names', name: this.languageService.getTranslationByKey('COMMUNITYSEARCHINTOPICNAMES')},
    {id: 'community_names', name: this.languageService.getTranslationByKey('COMMUNITYSEARCHINCOMMUNITYNAMES')}
  ];

  displayFilterOptions: any[] = [
    {id: 'all', name: this.languageService.getTranslationByKey('COMMUNITYSHOWALLFILTER')},
    {id: 'sunscribed_topics', name: this.languageService.getTranslationByKey('COMMUNITYSHOWONLYSUBSCRIBEDTOPICSFILTER')},
    {id: 'tranding_topics', name: this.languageService.getTranslationByKey('COMMUNITYSHOWONLYTRANDINGTOPICS')},
    {id: 'communities', name: this.languageService.getTranslationByKey('COMMUNITYSHOWONLYCOMMUNITIES')}
  ];

  imageSrc= "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSb72uP8MZ7wzWKhwGjQhb11TXHkMG5zo2ouw&";
  imageSrc1= "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSb72uP8MZ7wzWKhwGjQhb11TXHkMG5zo2ouw&";

  public activeStep = 0;
  public participantsGroupIDs: number[] = [8,6];
  public participantsMails: string[] = [];
  public pushUserIDs: number[] = [];
  pushGroupIDs: number[] = [];
  public steps: string[] = [this.languageService.getTranslationByKey('COMMUNITYTEXTCONTENTMENUTEXT'), this.languageService.getTranslationByKey('COMMUNITYSPLASHMENUTEXT'), this.languageService.getTranslationByKey('COMMUNITYEDITORPERMISSIONSMENUTEXT'), this.languageService.getTranslationByKey('COMMUNITYSUBSCRIBERSPERMISSIONSMENUTEXT')];

  close(){

  }
}
